import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as S from './ChooseCampaigns.styled';
import {
  ModalBase,
  ModalHeader,
  ModalFooter,
  ChooseBase,
  Buttons,
  ErrorComponent,
  ContentWrapp,
  Loader,
} from 'components';
import { useDebounce } from 'utils';
import { useToggleState } from './useToggleState';
import { Content } from './Content';
import { searchExcludeAPI } from 'services/searchExcludeAPI.service';

const ChooseCampaigns = ({ title, setSelectedCampaigns, selectedCampaigns }) => {
  const [search, setSearch] = useState('');
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const debouncedValue = useDebounce(search, 1500);

  const [trigger, { data: foundedCampaigns, isError, isFetching }] =
    searchExcludeAPI.useLazyFetchSerachCampaignsQuery();

  const {
    isActive,
    toggle,
    itemsToShow,
    handleSaveSelectedCampaigns,
    handleSearchOnChange,
    handleClearSearchValue,
    restore,
    flag,
  } = useToggleState(
    selectedCampaigns,
    foundedCampaigns,
    setSearch,
    setSelectedCampaigns,
    search,
    setIsOpen,
  );

  const handleClose = () => {
    restore();
    dispatch(searchExcludeAPI.util.resetApiState());
    setSearch('');
    setIsOpen(false);
  };

  useEffect(() => {
    if (search.length > 3 && debouncedValue.length > 3) {
      trigger(search);
    }
  }, [debouncedValue]);

  return (
    <>
      <Buttons.SecondaryNormal
        id='categories'
        style={{ width: '100%' }}
        onClick={() => setIsOpen(true)}
      >
        Choose Campaigns
      </Buttons.SecondaryNormal>
      {isOpen && (
        <ModalBase>
          <S.Box>
            <ModalHeader title={title} close={handleClose} />
            <S.Content>
              <ChooseBase.OneSection
                searchValue={search}
                searchOnChange={handleSearchOnChange}
                handleClearSearchValue={handleClearSearchValue}
                dontShowHeader
                title='Search Campaigns'
              >
                {isFetching && <Loader.Local delay={0.01} />}
                {isError && !isFetching > 0 && search.length > 3 && <ErrorComponent />}
                {!isFetching && (
                  <ContentWrapp
                    foundedItems={itemsToShow()}
                    search={search}
                    title='Use the search to choose a specific Campaigns.'
                  >
                    <Content
                      foundedCampaigns={itemsToShow()}
                      search={search}
                      isActive={isActive}
                      toggle={toggle}
                    />
                  </ContentWrapp>
                )}
              </ChooseBase.OneSection>
            </S.Content>
            <ModalFooter
              saveButtonText='Apply'
              saveButtonOnClick={handleSaveSelectedCampaigns}
              close={handleClose}
              saveButtonDisabled={flag.current}
            />
          </S.Box>
        </ModalBase>
      )}
    </>
  );
};

export default ChooseCampaigns;
